import { useEffect, useMemo, useState } from 'react';

import { 
  Box, 
  Paper, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  TablePagination, 
  Avatar
} from '@mui/material';

import { camposReporteEmpleados } from '../../../utils/camposReporteEmpleados';

export const ReporteDinamicoTable = ({campos, reporteData, reporteCount, page, setPage, setRowsPerPage, setSkipRow, rowsPerPage}) => {

  // ? USE-STATE PARA LOS CAMPOS Y COLUMNAS
  const [columns, setColumns] = useState([]);
  const [campoSeleccionados, setCampoSeleccionados] = useState([]);
  
   // * FUNCIONES PARA PAGINACION.
	const handleChangePage = (event, newPage) => {
		setSkipRow(newPage * rowsPerPage);
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
		setSkipRow(0);
	};
  
  useEffect(() => {
    
    if(Object.keys(campos).length > 0){
      const listaCampos = Object.keys(campos).filter(x => campos[x] === true);
      const camposSeleccionados = camposReporteEmpleados.filter((x) => listaCampos.find(y => y === x.campo));

      let arr = [];

      for (let index = 0; index < camposSeleccionados.length; index++) {
        
        const data = camposSeleccionados[index];

        const campoAdd = { field: data.campo, headerName: data.label, width: 70 };
        arr.push(campoAdd);
      }

      setColumns(arr);
      setCampoSeleccionados(listaCampos);
    }

    
  }, [campos])

  // * COMPONENTE PERSONALIZADO DE LA IMAGEN. 
  const ImageComponent = ({ empleado }) => {
    
    // Memoriza la URL de la imagen solo cuando `empleado.foto` cambia
    const imageUrl = useMemo(() => {
      return `${empleado.foto}?cacheBust=${new Date().getTime()}`;
    }, [empleado.foto]);

    const component = (
      <>
        <Avatar
        sx={{
          width: 80,
          height: 80,
          marginLeft: 0,
          border: "solid",
          borderWidth: 0.5,
          borderColor: "#003876",
        }}
        alt={empleado.nombres}
        src={imageUrl}
        />
      </>
    )
  
    return component;
  }
  

  return (
    <Box sx={{ mt: 3 }} maxWidth={'100%'}>
      <Paper sx={{ mb: 2 }} elevation={3}>
        <TableContainer>

          <Table stickyHeader>
            <TableHead>
              <TableRow>

                <TableCell hidden={!columns.some(x => x.field === "foto")} sx={{fontWeight: 'bold'}}>
                  {columns.find(x => x.field === "foto")?.headerName}
                </TableCell>

                {
                  columns.filter(x =>  x.field !== "foto").map((item) => (
                    <TableCell key={item.field} sx={{fontWeight: 'bold'}}>
                      {item.headerName}
                    </TableCell>
                  ))
                }
                
              </TableRow>
            </TableHead>

            <TableBody>

              {
                reporteData.map((item, index) => (
                  <TableRow key={index}>

                    <TableCell hidden={item["foto"] === undefined | !columns.some(x => x.field === "foto")}>
                      <ImageComponent empleado={item} />
                    </TableCell>

                    {
                    campoSeleccionados.map((campo, index) => (
                      campo !== "foto" ?
                        <TableCell key={index} >
                          {
                            item[campo]
                          }
                        </TableCell>

                        : <></>
                      )
                      )
                    }
                    
                  </TableRow>
                ))
              }

            </TableBody>

          </Table>

        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[25, 50, 100]}
          component="div"
          count={reporteCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Box>
  )
}
